module.exports = __webpack_public_path__ + "static/media/rsz_banner_slider5.3876cbd2.jpg";